import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import { OrderedMap, Map } from 'immutable';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import PopoverMenu from 'shared/components/menus/popoverMenu';
import ColorPicker from 'shared/components/pickers/colorPicker';
import AlignPicker from 'shared/components/pickers/alignPicker';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import CuesheetToolbarStore from 'shared/flux/stores/cuesheet/CuesheetToolbarStore';
import UIRegions from 'shared/constants/UIRegions';

import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import CuesheetCellActions from 'shared/flux/actions/cuesheet/CuesheetCellActions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

const fontSizeMenuId = 'fontSizeMenu';
// const fontAlignMenuId = 'fontAlignMenu';

export default React.createClass({
  displayName: 'CuesheetToolbar',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connect(CuesheetToolbarStore, 'cuesheetToolbar'),
    Reflux.connectFilter(CuesheetStore, 'cellToolbarEnabled', (state) =>
      state.get('cellToolbarEnabled'),
    ),
  ],

  render() {
    if (!this._isEnabled()) return null;

    let buttonStates = this._getButtonStates();

    let foreColor = buttonStates.get('foreColor'),
      backColor = buttonStates.get('backColor');

    let generalClasses = ['cs-toolbar-item'],
      activeClasses = generalClasses.concat(['active']);

    let fontAlignClasses = generalClasses;
    let fontAlign = buttonStates.get('hasFontAlign');

    if (fontAlign === 'center') fontAlignClasses = activeClasses;
    if (fontAlign === 'right') fontAlignClasses = activeClasses;

    let boldClasses = buttonStates.get('hasFontBold')
        ? activeClasses
        : generalClasses,
      uppercaseClasses = buttonStates.get('hasUppercase')
        ? activeClasses
        : generalClasses,
      italicClasses = buttonStates.get('hasFontItalic')
        ? activeClasses
        : generalClasses,
      textColorClasses = foreColor
        ? generalClasses.concat(['color-picker-circle-' + foreColor])
        : generalClasses,
      backgroundColorClasses = backColor
        ? generalClasses.concat(['color-picker-circle-' + backColor])
        : generalClasses;

    let fontSizeType = buttonStates.get('hasFontSize');
    let fontSizeClasses = generalClasses;

    if (fontSizeType === 'small') fontSizeClasses = activeClasses;
    if (fontSizeType === 'large') fontSizeClasses = activeClasses;
    if (fontSizeType === 'xlarge') fontSizeClasses = activeClasses;

    const toolbarItemGroupClassname = 'cs-toolbar-item-group';

    return (
      <div className="cs-toolbar">
        <div className="cs-toolbar-item-group">
          <div className={classNames(fontSizeClasses)}>
            {this._getFontSizeNode()}
          </div>
          <div className={classNames(boldClasses)}>
            <Icon name="bold" onClick={this._handleFontBoldClick} />
          </div>
          <div className={classNames(italicClasses)}>
            <Icon name="italic" onClick={this._handleFontItalicClick} />
          </div>
          <div className={classNames('uppercase-wrapper', uppercaseClasses)}>
            {this._getFontCaseNode()}
          </div>
          <div className={classNames(fontAlignClasses)}>
            {this._getFontAligneNode(fontAlign)}
          </div>
          <div className={classNames(textColorClasses)}>
            {this._getColorPickerFor(
              'textColor',
              'font',
              this._handleTextColorChange,
              this._handleTextColorClear,
            )}
          </div>
        </div>

        <div className={toolbarItemGroupClassname}>
          <div className={classNames(backgroundColorClasses)}>
            {this._getColorPickerFor(
              'backgroundColor',
              'eyedropper',
              this._handleBackgroundColorChange,
              this._handleBackgroundColorClear,
            )}
          </div>
          <div className={classNames(generalClasses)}>
            <Icon name="eraser" onClick={this._handleClearAllClick} />
          </div>
          <div className={classNames(generalClasses)}>
            <WithTooltip
              placement="bottom"
              tip={TooltipConstants.CSToolbarImage}
            >
              <Icon name="file-image-o" onClick={this._handleAddAssetClick} />
            </WithTooltip>
          </div>
          <div className={classNames(generalClasses)}>
            <WithTooltip
              placement="bottom"
              tip={TooltipConstants.CSToolbarLink}
            >
              <Icon name="link" onClick={this._handleAddLinkClick} />
            </WithTooltip>
          </div>
          <div className={classNames(generalClasses)}>
            <WithTooltip
              placement="bottom"
              tip={TooltipConstants.CSToolbarTimeStamp}
            >
              <Icon name="clock-o" onClick={this._handleAddTimeStampClick} />
            </WithTooltip>
          </div>
        </div>

        {/* Temporary removal of uppercase font styling see to remove all changes of this change https://github.com/SHOFLO/app.v4/pull/1614/files
        <Col sm={2} md={2} className={classNames('uppercase-wrapper',uppercaseClasses)}>
          <span className="uppercase-icon" onClick={this._handleUppercaseClick}>aA</span>
        </Col> */}
        {/* Leaving this for testing row height issues...
        <Col sm={2} md={2} className={classNames(generalClasses)}>
          <Icon name="arrows-v" onClick={() => CuesheetRowActions.bustRowHeightCache()}/>
        </Col>
        */}
      </div>
    );
  },

  _isEnabled() {
    return this.state.cellToolbarEnabled;
  },

  _getButtonStates() {
    return this.state.cuesheetToolbar;
  },

  _getColorPickerFor(type, icon, onColorClick, onClearClick) {
    return (
      <ColorPicker
        popoverId={type + 'MenuId'}
        icon={icon}
        onColorClick={onColorClick}
        onClearClick={onClearClick}
      />
    );
  },

  _getFontSizeNode() {
    return (
      <PopoverMenu
        show={this.state.popoverVisibility.get(fontSizeMenuId)}
        config={this._getFontSizeMenuConfig()}
        className="font-size-popover font-toolbar-menu"
      />
    );
  },

  _getFontAligneNode(type) {
    return (
      <AlignPicker type={type} onAlignClick={this._handleFontAlignClick} />
    );
  },

  _getFontCaseNode() {
    return (
      <div className="uppercase-icon" onClick={this._handleUppercaseClick}>
        <span className="small-icon">
          <Icon name="font" />
        </span>
        <span className="icon">
          <Icon name="font" />
        </span>
      </div>
    );
  },

  _getFontSizeMenuConfig() {
    return Map({
      id: fontSizeMenuId,
      icon: 'text-height',
      placement: 'bottom',
      onHide: () => PopoverActions.hide(fontSizeMenuId),
      onClick: () => PopoverActions.show(fontSizeMenuId),
      items: OrderedMap({
        small: Map({
          content: 'Small',
          onClick: () => this._handleFontSizeChange('small'),
        }),
        normal: Map({
          content: 'Normal',
          onClick: () => this._handleFontSizeChange('normal'),
        }),
        large: Map({
          content: 'Large',
          onClick: () => this._handleFontSizeChange('large'),
        }),
        xlarge: Map({
          content: 'X-Large',
          onClick: () => this._handleFontSizeChange('xlarge'),
        }),
      }),
    });
  },

  _getFormat() {
    return this.state.cuesheetToolbar;
  },

  _handleAddAssetClick(e) {
    e.stopPropagation();
    CuesheetCellActions.showCuesheetModal(UIRegions.CellAsset);
  },

  _handleAddLinkClick(e) {
    e.stopPropagation();
    CuesheetCellActions.showCuesheetModal(UIRegions.CellLink);
  },

  _handleAddTimeStampClick() {
    CuesheetCellActions.saveSelectedCellTextWithTimeStamp();
  },

  _handleFontSizeChange(fontSize) {
    CuesheetCellActions.saveSelectedCellFormat(Map({ fontSize }));
  },

  _handleFontBoldClick() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        bold: this._getButtonStates().get('hasFontBold') ? false : true,
      }),
    );
  },

  _handleUppercaseClick() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        uppercase: this._getButtonStates().get('hasUppercase') ? false : true,
      }),
    );
  },

  _handleFontItalicClick() {
    CuesheetCellActions.saveSelectedCellFormat(
      Map({
        italic: this._getButtonStates().get('hasFontItalic') ? false : true,
      }),
    );
  },

  _handleFontAlignClick(type) {
    CuesheetCellActions.saveSelectedCellFormat(Map({ align: type }));
  },

  _handleTextColorChange(foreColor) {
    CuesheetCellActions.saveSelectedCellFormat(Map({ foreColor }));
  },

  _handleTextColorClear() {
    CuesheetCellActions.saveSelectedCellFormat(Map({}), 'foreColor');
  },

  _handleBackgroundColorChange(backColor) {
    CuesheetCellActions.saveSelectedCellFormat(Map({ backColor }));
  },

  _handleBackgroundColorClear() {
    CuesheetCellActions.saveSelectedCellFormat(Map({}), 'backColor');
  },

  _handleClearAllClick() {
    CuesheetCellActions.saveSelectedCellFormat(null);
  },
});
